var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoveninversorLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0H7V36.5C7 40.1 5.66667 41 5 41H0V46.5C11.6 48.5 13.8333 43 13.5 40V0Z",
    fill: "#FF9C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H16.5V6.5H22.5V0Z",
    fill: "#FF9C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8H16.5V46.5H22.5V8Z",
    fill: "#FF9C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 0H39.5V36.5C39.5 40.1 40.8333 41 41.5 41H46.5V46.5C34.9 48.5 32.6667 43 33 40V0Z",
    fill: "#FF9C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H30V6.5H24V0Z",
    fill: "#FF9C00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8H30V46.5H24V8Z",
    fill: "#FF9C00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoveninversorLogo);
export default __webpack_public_path__ + "static/media/joveninversor-logo.50cbc5623e036b420a6d93cacbd4fad5.svg";
export { ForwardRef as ReactComponent };